/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Direction
 */
export type CreateSecuritiesTransferRequestDirection = typeof CreateSecuritiesTransferRequestDirection[keyof typeof CreateSecuritiesTransferRequestDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateSecuritiesTransferRequestDirection = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
  NONE: 'NONE',
} as const;
